import axios from 'axios';
import variables from "../variables.js";
var hostAdress = variables.getVariable("api.base");
var apiKey = variables.getVariable("api.key");

// Interceptor
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['x-api-key'] = apiKey;

export default {
	HOST: hostAdress,
	TIMEOUT: 10000,
	SERVER_URL : hostAdress,
	properties: {
		transformResponse: [function (data) {
			return JSON.parse(data);
		}]
	},
	getInstance(){
		var client = axios.create({
		  baseURL: this.SERVER_URL,
		  timeout: this.TIMEOUT
		});



		return client;
	}
};
